export default __webpack_public_path__ + "static/media/applications-image-11.29805b1c.jpg";